import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import { wordCount } from '../../../utils/string';
import s from './Paragraph.scss';

const Paragraph = ({ setup, content, attrs = {}, trim = false }) => {
	if (!content) return null;
	const styles = {};
	const [expanded, toggleExpand] = useState(false);
	if (attrs.align) styles.textAlign = attrs.align;
	if (attrs.textAlign) styles.textAlign = attrs.textAlign;
	if (attrs.textColor) styles.color = attrs.textColor;

	if (trim) {
		const [before, after] = wordCount(content.rawText, 60);

		if (after !== '') {
			const readMoreHandler = (e) => {
				e.preventDefault();
				toggleExpand((prev) => !prev);
			};

			return (
				<div className={[s.paragraph, (expanded ? s.paragraph__expanded : null)].join(' ')} style={styles}>
					<div className={s.paragraph_before} dangerouslySetInnerHTML={{ __html: purifier(before, { ADD_ATTR: ['target'] }) }} />
					{ !expanded && <a className={s.paragraph_readMore} href="#expand-description" onClick={readMoreHandler}>{ translate(setup, 'expandDescription') }</a> }
					<div className={s.paragraph_after} dangerouslySetInnerHTML={{ __html: purifier(after, { ADD_ATTR: ['target'] }) }} />
				</div>
			);
		}
	}

	return (
		<p className={s.paragraph} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, { ADD_ATTR: ['target'] }) }} style={styles} />
	);
};

export default hot(module)(Paragraph);
